// extracted by mini-css-extract-plugin
module.exports = {"date-period-field":"_-web-client-js-react-components-dates-___DatePeriodField-module__date-period-field___3WYOn"};